/* global mejs */
import $ from 'jquery';
import core from '../core';

class HeroBanner {
    static playerInstance = null;

    /**
     * Setup
     */
    static setup() {
        HeroBanner.adjustMedia();
        HeroBanner.bindEvents();
    }

    /**
     * Events
     */
    static bindEvents() {
        $(document).on('click', '.js-hero-banner__media-volume-btn', HeroBanner.toggleVolume);
    }

    /**
     * Adjust Media
     */
    static adjustMedia() {
        const $mediaEl = $('.js-hero-banner__media');

        if (!$mediaEl.length) {
            return;
        }

        const mediaWidth = $mediaEl.width();
        const mediaHeight = $mediaEl.height();

        const $mediaRatioEl = $('.js-hero-banner__media-ratio');
        const mediaRatioWidth = $mediaRatioEl.width();
        const mediaRatioHeight = $mediaRatioEl.height();

        const x = mediaRatioWidth < mediaWidth ? mediaWidth - mediaRatioWidth : (mediaHeight - mediaRatioHeight) * 2;
        const y = mediaRatioHeight < mediaHeight ? mediaHeight - mediaRatioHeight : mediaRatioHeight - mediaHeight;

        const $mediaWrapperEl = $('.js-hero-banner__media-wrapper');

        $mediaWrapperEl.css({
            top: -y / 2,
            right: -x / 2,
            left: -x / 2,
            bottom: -y / 2,
        });
    }

    /**
     * Resize
     */
    static resize() {
        HeroBanner.adjustMedia();
    }

    /**
     * Toggle volume
     */
    static toggleVolume(evt) {
        if (evt) {
            evt.preventDefault();
        }

        const $targetEl = $(evt.currentTarget);
        const id = $('.js-hero-banner__media .mejs-video').attr('id') || '';

        HeroBanner.playerInstance = mejs.players[id];

        if (!HeroBanner.playerInstance) {
            return;
        }

        if (!$targetEl.hasClass('is--active')) {
            // mejs.players[id].setMuted(true);
            HeroBanner.playerInstance.muted = false;
            HeroBanner.playerInstance.setVolume(1);

            $targetEl.attr('title', core.config.i18n.mute);
            $targetEl.addClass('is--active');
        }
        else {
            // mejs.players[id].setMuted(false);
            HeroBanner.playerInstance.muted = true;
            HeroBanner.playerInstance.setVolume(0);

            $targetEl.attr('title', core.config.i18n.unmute);
            $targetEl.removeClass('is--active');
        }
    }
}

core.Component('hero-banner', {
    methods: {
        _resize: HeroBanner.resize,
    }
});

core.Ready(HeroBanner.setup);
